"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const redux_1 = require("redux");
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const QCurrency_1 = __importDefault(require("components/QCurrency"));
const BudgetSummaryItem = ({ title, amount, classes, currency, disableColor, formatAmount }) => {
    const colorClass = !disableColor && (amount < 0 ? 'negative' : 'positive');
    return (<div className={classes.summaryItem}>
      <Typography_1.default variant="body2" className={classes.summaryItemHeader}>
        {title}
      </Typography_1.default>
      <Typography_1.default variant="body1" className={(0, classnames_1.default)(classes.summaryItemBody, colorClass)}>
        {formatAmount(amount, currency, true)}
      </Typography_1.default>
    </div>);
};
exports.default = (0, redux_1.compose)((0, QCurrency_1.default)())(BudgetSummaryItem);
